import { render, staticRenderFns } from "./BridgeDialog.vue?vue&type=template&id=5a0dcf72&scoped=true&"
import script from "./BridgeDialog.vue?vue&type=script&lang=js&"
export * from "./BridgeDialog.vue?vue&type=script&lang=js&"
import style0 from "./BridgeDialog.vue?vue&type=style&index=0&id=5a0dcf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0dcf72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
